import { useState, useEffect, useCallback } from "react";
import "@/App.css";
import "@/accessibility.css";
import useSmoothScroll from "@/lib/useSmoothScroll";
import Nav from "@/components/portfolio/Nav";
import Hero from "@/components/portfolio/Hero";
import Featured from "@/components/portfolio/Featured";
import Gallery from "@/components/portfolio/Gallery";
import About from "@/components/portfolio/About";
import Services from "@/components/portfolio/Services";
import Clients from "@/components/portfolio/Clients";
import Callback from "@/components/portfolio/Callback";
import Contact from "@/components/portfolio/Contact";
import Footer from "@/components/portfolio/Footer";
import CaseModal from "@/components/portfolio/CaseModal";
import BackToTop from "@/components/portfolio/BackToTop";
import Admin from "@/components/portfolio/Admin";

function App() {
  useSmoothScroll();
  const [active, setActive] = useState(null);

  const openProject = useCallback((project) => {
    window.history.pushState({ portfolioModal: true }, "", `#project-${project.id}`);
    setActive(project);
  }, []);
  const closeProject = useCallback(() => {
    if (window.history.state?.portfolioModal) window.history.back();
    else setActive(null);
  }, []);
  useEffect(() => {
    const onPop = () => setActive(null);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  const isAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/admin");

  if (isAdmin) {
    return <Admin />;
  }

  return (
    <div className="app" data-testid="app-root">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Nav />
      <main id="main-content" tabIndex={-1}>
        <Hero />
        <Featured onOpen={openProject} />
        <Gallery />
        <About />
        <Services />
        <Clients />
        <Callback />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
      {active && <CaseModal project={active} onClose={closeProject} />}
    </div>
  );
}

export default App;
